import type { GameResponse } from '@warcarp/api-types'
import { gameForCase, visualUser } from './visual/transport'

export const DESKTOP_HOME_CONCEPTS = [
  { id: 'field-desk', name: 'Field desk', description: 'A familiar centered list, capped at 960px. Navigation and actions share its edges.' },
  { id: 'command-column', name: 'Command column', description: 'A comfortable game queue with a narrow rail for open games and quick actions.' },
  { id: 'card-table', name: 'Card table', description: 'Two columns of map cards. More games visible without stretching each row.' },
  { id: 'turn-board', name: 'Turn board', description: 'Your turn, waiting and invitations in separate columns, with actionable games first.' },
  { id: 'compact-roster', name: 'Compact roster', description: 'A denser centered queue with smaller map previews and consistent spacing.' },
  { id: 'frontline', name: 'Frontline', description: 'Your turns get the first row, with waiting games below and a small open-game rail.' },
] as const
export type DesktopHomeConcept = typeof DESKTOP_HOME_CONCEPTS[number]
export const HOME_SAMPLE_USER_ID = visualUser.id

function sample(id: string, name: string, mapId: string, kind: 'mine' | 'waiting' | 'invite' | 'public' | 'complete'): GameResponse {
  const game = gameForCase({ id, source: '', params: {}, data: kind === 'complete' ? 'complete' : kind === 'waiting' ? 'waiting' : 'attack' }) as unknown as GameResponse
  game.id = `desktop-sample-${id}`
  game.name = name
  game.mapId = mapId
  game.players = game.players.map(player => player.userId === HOME_SAMPLE_USER_ID ? { ...player, displayName: 'yakuza' } : player)
  if (kind === 'invite' || kind === 'public') {
    game.status = 'LOBBY'
    game.state = null
    game.adminId = game.players[1]!.userId
    game.players = game.players.filter(player => player.userId !== HOME_SAMPLE_USER_ID)
    game.maxPlayers = 5
    game.viewerInvitationStatus = kind === 'invite' ? 'pending' : null
    game.isPublic = kind === 'public'
  }
  return game
}
export const HOME_SAMPLE_TURNS = [
  sample('north', 'Northern Front', 'minnesota', 'mine'),
  sample('carpathia', 'Carpathian Patrol', 'carpathia', 'mine'),
]
export const HOME_SAMPLE_WAITING = [
  sample('salt', 'Salt and Steel', 'world-classic', 'waiting'),
  sample('crossing', 'The Long Crossing', 'great-lakes', 'waiting'),
  sample('ridge', 'Hold the Ridge', 'japan', 'waiting'),
  sample('winter', 'Winter Quarters', 'arctic', 'waiting'),
]
export const HOME_SAMPLE_INVITES = [sample('fortune', 'Fortunes of the Carp', 'carpathia', 'invite')]
export const HOME_SAMPLE_OPEN = [sample('fleet', 'Paper Fleet', 'carpathia', 'public')]
export const HOME_SAMPLE_COMPLETED = [
  sample('last', 'Last Carp Standing', 'world-classic', 'complete'),
  sample('cold', 'Cold Water Campaign', 'arctic', 'complete'),
  sample('old', 'Old World Orders', 'castles', 'complete'),
]
